import './preloader.css';

const Preloader = () => <div id="preloader"></div>;

export default Preloader;